import React from 'react';

import { ProductModule } from 'src/api/contentful/contentTypes.cloverdotcom';
import { FlatEntry } from 'src/services/cms/flattenContentful';

interface ProductDetailsProps extends React.HTMLAttributes<HTMLElement> {
  details?: FlatEntry<ProductModule> | false;
}

export const ProductDetails: React.FC<ProductDetailsProps> = ({ details, ...props }) => (
  details ? <button {...props} /> : <div {...props} />
);

ProductDetails.displayName = 'ProductDetails';
